import React from 'react';
import { Box, Grid, GridItem, Heading, Text } from '@chakra-ui/react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { TeamCarousel } from './TeamCarousel';
import { gallery } from '../data/gallery';
function MosaicTile({
  src,
  alt,
  caption,
  clip
}: {
  src: string;
  alt: string;
  caption: string;
  clip: string;
}) {
  return <Box role="group" position="relative" h="100%" minH={{
    base: '14rem',
    md: 'auto'
  }} overflow="hidden" border="1px solid" borderColor="rgba(242,183,5,0.3)" sx={{
    clipPath: clip
  }} data-id="element-92" data-mp="2pnamdzxu5chm">
      <Box as="img" src={src} alt={alt} loading="lazy" w="100%" h="100%" objectFit="cover" transition="transform 0.6s ease" _groupHover={{
      transform: 'scale(1.07)'
    }} data-id="element-93" data-mp="2zeexgoke4d76" />
      <Box position="absolute" inset={0} bg="linear-gradient(180deg, rgba(13,13,13,0) 40%, rgba(13,13,13,0.9) 100%)" opacity={{
      base: 1,
      md: 0
    }} transition="opacity 0.4s ease" _groupHover={{
      opacity: 1
    }} aria-hidden="true" data-id="element-94" data-mp="26upxetl9brj3" />
      <Box position="absolute" bottom={0} left={0} right={0} px={5} pb={5} opacity={{
      base: 1,
      md: 0
    }} transform={{
      base: 'none',
      md: 'translateY(10px)'
    }} transition="all 0.4s cubic-bezier(0.22,1,0.36,1)" _groupHover={{
      opacity: 1,
      transform: 'translateY(0)'
    }} data-id="element-95" data-mp="w9jhlm0cvr6u">
        <Box w="2rem" h="2px" bg="crimson.500" mb={3} data-id="element-96" data-mp="ddtetwklmqrw" />
        <Text fontSize={{
        base: 'sm',
        md: 'md'
      }} fontWeight={600} color="gold.300" data-id="element-97" data-mp="demmr0vanmbm">
          {caption}
        </Text>
      </Box>
    </Box>;
}
export function Gallery() {
  const [featured, ...rest] = gallery;
  return <Box as="section" id="galeria" bg="ink.900" position="relative" pt={{
    base: 16,
    md: 28
  }} pb={{
    base: 16,
    md: 24
  }} mt={{
    md: '-4vw'
  }} sx={{
    clipPath: {
      base: 'none',
      md: 'polygon(0 0, 100% 4vw, 100% 100%, 0 100%)'
    }
  }} data-id="element-98" data-mp="1su20hvy2r1gy">
      <Box px={{
      base: 5,
      md: 10,
      xl: 16
    }} data-id="element-99" data-mp="3pu6h7v7gpx7v">
        <Reveal data-id="element-100" data-mp="3ptekui61jvgj">
          <SectionHeading eyebrow="Nuestro espacio" title="Galería" description="Imágenes de nuestro templo y de los elementos tradicionales que acompañan cada consulta." tone="dark" data-id="element-101" data-mp="3ptwqg5elfm14" />
        </Reveal>

        <Reveal delay={0.1} data-id="element-102" data-mp="3b4ih2xb0p4lq">
          <Grid mt={{
          base: 10,
          md: 16
        }} templateColumns={{
          base: '1fr',
          md: '1.55fr 1fr'
        }} templateRows={{
          base: 'auto',
          md: '15rem 15rem'
        }} gap={{
          base: 4,
          md: 5
        }} data-id="element-103" data-mp="3b5tiiqgzq09o">
            <GridItem rowSpan={{
            md: 2
          }} minH={{
            base: '18rem',
            md: 'auto'
          }} data-id="element-104" data-mp="3kwwmc01b0tcn">
              <MosaicTile src={featured.src} alt={featured.alt} caption={featured.caption} clip="polygon(0 0, 100% 0, 100% 93%, 90% 100%, 0 100%)" data-id="element-105" data-mp="3g324711ckmfo" />
            </GridItem>
            {rest.map((item, index) => <GridItem key={item.src} data-id="element-106" data-mp="12wc8csk70q5t" data-mpi={index}>
                <MosaicTile src={item.src} alt={item.alt} caption={item.caption} clip={index === 0 ? 'polygon(0 0, 100% 0, 100% 100%, 8% 100%, 0 82%)' : 'polygon(0 0, 92% 0, 100% 16%, 100% 100%, 0 100%)'} data-id="element-107" data-mp="17o3pkchgljja" />
              </GridItem>)}
          </Grid>
        </Reveal>

        <Box mt={{
        base: 20,
        md: 28
      }} textAlign="center" data-id="element-108" data-mp="1qmpr1sgw1cnq">
          <Reveal data-id="element-109" data-mp="1cnzv4g5t1j0y">
            <Text fontSize="xs" fontWeight={700} letterSpacing="0.3em" textTransform="uppercase" color="gold.400" mb={4} data-id="element-110" data-mp="1cmf0kqjhq033">
              Nuestro equipo
            </Text>
            <Heading as="h3" fontSize={{
            base: '1.6rem',
            md: '2.6rem'
          }} color="cream.50" maxW="46rem" mx="auto" mb={4} data-id="element-111" data-mp="674mfjfnwf1d">
              Contamos con Brujos y Hechiceros Expertos En todo tipo de Magia..
            </Heading>
            <Box w="5rem" h="3px" bg="crimson.500" mx="auto" mb={5} data-id="element-112" data-mp="bqgf5kpx4qh0" />
            <Text fontSize={{
            base: 'md',
            md: 'lg'
          }} color="cream.200" opacity={0.85} maxW="44rem" mx="auto" data-id="element-113" data-mp="7pmrmsge1don">
              Cada consulta se atiende de forma personalizada y se explica con claridad antes de
              comenzar. Los resultados pueden variar según cada persona.
            </Text>
          </Reveal>

          <Box mt={{
          base: 10,
          md: 14
        }} data-id="element-114" data-mp="vepf4gxpe0r2">
            <TeamCarousel data-id="element-115" data-mp="vdnvho2mg5xq" />
          </Box>
        </Box>
      </Box>
    </Box>;
}